import orderBy from 'lodash/orderBy';

export const orderCommentsByAsc = (comments) =>
  orderBy(comments, ['created_at'], 'asc');

export const orderCommentsByDesc = (comments, sortBy) => {
  if (sortBy === 'votes') {
    return orderBy(comments, ['votes.score'], ['desc']);
  }

  // Sort by recents
  return orderBy(comments, ['created_at'], 'desc');
};

export const getFirstCommentsDesc = (comments, sortBy, maxComments) =>
  orderCommentsByDesc(comments, sortBy)?.slice(0, maxComments);

export const getLastCommentsAsc = (comments, maxComments) =>
  comments?.slice(comments.length - maxComments, comments.length);

export const addComment = ({ comment, comments }) => [...comments, comment];

export const deleteComment = ({ id, comments }) =>
  comments.filter((element) => element.id !== id);

export const editComment = ({ comment, comments }) => {
  const { id } = comment;

  return comments.map((obj) => (obj.id === id ? comment : obj));
};

export const getImages = (images) =>
  images && [
    ...images.map((image) => ({
      type: 'image',
      file: image.file_name,
      id: image.id,
      url: image.file_url,
    })),
  ];

export const isReply = (commentableType) => commentableType === 'Comment';
